import { useState } from 'react';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import s from './ErrorToolTip.module.css';

type ErrorToolTipProps = {
  isErrorVisible: boolean;
  messages: string[] | undefined;
};

function ErrorToolTip({ isErrorVisible, messages }: ErrorToolTipProps) {
  const [isToolTipOpen, setIsToolTipOpen] = useState(false);

  if (!isErrorVisible) {
    return null;
  }

  return (
    <>
      {isToolTipOpen && (
        <div className={s.errorToolTip}>
          {messages &&
            messages.map((msg, index) => (
              <p key={index} className={s.errorMessage}>
                {msg}
              </p>
            ))}
        </div>
      )}
      <button
        type="button"
        className={s.errorToolTipButton}
        onClick={() => setIsToolTipOpen(!isToolTipOpen)}>
        <PriorityHighIcon />
      </button>
    </>
  );
}

export default ErrorToolTip;
